/*
 *
 * LinkSettings constants
 *
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getSurveyLocationResetExceptionRules } from 'containers/SurveyPage/constants';
import endPageMessages from './endPageMessages';

export const FETCH_LINK_SETTINGS = 'app/LinkSettings/FETCH_LINK_SETTINGS';
export const FETCH_LINK_SETTINGS_SUCCESS =
  'app/LinkSettings/FETCH_LINK_SETTINGS_SUCCESS';
export const FETCH_LINK_SETTINGS_ERROR =
  'app/LinkSettings/FETCH_LINK_SETTINGS_ERROR';

export const UPDATE_LINK_SETTINGS = 'app/LinkSettings/UPDATE_LINK_SETTINGS';
export const UPDATE_LINK_SETTINGS_SUCCESS =
  'app/LinkSettings/UPDATE_LINK_SETTINGS_SUCCESS';

export const SAVE_LINK_SETTINGS = 'app/LinkSettings/SAVE_LINK_SETTINGS';
export const SAVE_LINK_SETTINGS_SUCCESS =
  'app/LinkSettings/SAVE_LINK_SETTINGS_SUCCESS';
export const SAVE_LINK_SETTINGS_ERROR =
  'app/LinkSettings/SAVE_LINK_SETTINGS_ERROR';

export const NOTIFICATION_RESPONSES_OPTIONS_DEFAULT = '1';
export const NOTIFICATION_RESPONSES_OPTIONS = [
  { value: '2', label: 'For every response' },
  { value: '1', label: 'Once a day' },
  { value: '4', label: 'Once a week' },
  { value: '3', label: 'Once a month' },
];

export const NOTIFICATION_RESPONSES_OFF = 0;

export const SURVEY_LINK_EXPIRE_OPTIONS = [
  { value: 'never', label: 'Never' },
  { value: 'custom', label: 'Set date and time' },
];

export const SURVEY_END_PAGE_DEFAULT = 0;
export const SURVEY_END_PAGE_RESULTS = 1;
export const SURVEY_END_PAGE_CUSTOM = 2;
export const SURVEY_END_PAGE_NO_REDIRECT = 3;
export const SURVEY_END_PAGE_PRODEGE = 4;

export const SURVEY_END_PAGE_OPTIONS = [
  {
    value: SURVEY_END_PAGE_DEFAULT,
    label: <FormattedMessage {...endPageMessages.pollfish} />,
  },
  {
    value: SURVEY_END_PAGE_RESULTS,
    label: <FormattedMessage {...endPageMessages.results} />,
  },
  {
    value: SURVEY_END_PAGE_CUSTOM,
    label: <FormattedMessage {...endPageMessages.custom} />,
  },
  {
    value: SURVEY_END_PAGE_PRODEGE,
    label: <FormattedMessage {...endPageMessages.prodege} />,
  },
];

export const VARIABLES = {
  MAX_RESPONSES: 'maxResponses',
  MULTIPLE_RESPONSES: 'multipleResponses',
  NOTIFICATIONS: 'notifications',
  LINK_EXPIRE: 'linkExpire',
  EXPIRE_TIMEZONE: 'expireTimezone',
  LINK_EXPIRE_DATE: 'linkExpireDate',
  LINK_EXPIRE_TIME: 'linkExpireTime',
  LINK_EXPIRE_SELECT: 'linkExpireSelect',
  CUSTOM_THANK_YOU_MESSAGE: 'customThankYouMessage',
  SURVEY_END_PAGE: 'surveyEndPage',
  SURVEY_COMPLETED_URL: 'surveyCompletedUrl',
  SCREENOUT_URL: 'screenoutUrl',
  QUALITY_TERMINATE_URL: 'qualityTerminateUrl',
  PROFILING_TERMINATE_URL: 'profilingTerminateUrl',
  OVERQUOTA_TERMINATE_URL: 'overquotaTerminateUrl',
};

export const VALIDATION_ERRORS = {
  GENERIC: 'GENERIC',
  MAX_RESPONSES: 'MAX_RESPONSES',
  MAX_RESPONSES_LIMIT: 'MAX_RESPONSES_LIMIT',
  THANK_YOU_MESSAGE: 'THANK_YOU_MESSAGE',
  SCREENOUT_URL: 'SCREENOUT_URL',
  SURVEY_COMPLETED_URL: 'SURVEY_COMPLETED_URL',
  CONTAINS_URL: 'CONTAINS_URL',
  PAST_DATE: 'PAST_DATE',
  MISSING_DATE: 'MISSING_DATE',
  INVALID_URL: 'INVALID_URL',
  EMPTY_URL: 'EMPTY_URL',
  QUALITY_TERMINATE: 'QUALITY_TERMINATE',
  PROFILING_TERMINATE: 'QUALITY_TERMINATE',
};

export const postValues = [
  VARIABLES.MAX_RESPONSES,
  VARIABLES.MULTIPLE_RESPONSES,
  VARIABLES.NOTIFICATIONS,
  VARIABLES.LINK_EXPIRE,
  VARIABLES.EXPIRE_TIMEZONE,
  VARIABLES.CUSTOM_THANK_YOU_MESSAGE,
  VARIABLES.SURVEY_END_PAGE,
  VARIABLES.SURVEY_COMPLETED_URL,
  VARIABLES.SCREENOUT_URL,
  VARIABLES.QUALITY_TERMINATE_URL,
  VARIABLES.PROFILING_TERMINATE_URL,
  VARIABLES.OVERQUOTA_TERMINATE_URL,
];

export const locationResetExceptionRoutes = [
  ...getSurveyLocationResetExceptionRules(),
];

export const LINK_EXPIRE_OFFSET_HOURS = 1;
